import { ChevronRight, Eye, FileText } from "lucide-react";
import type { Article } from "../../store/apis/helpCenter.api";
import { getReadTime } from "../../utils/helpCenter";

interface HelpArticleRowProps {
  article: Article;
  categoryName: string;
  onOpen: (articleId: string) => void;
}

function formatViews(views?: number): string {
  if (!views) return "0";
  if (views >= 1000) {
    const k = views / 1000;
    return `${k % 1 === 0 ? k.toFixed(0) : k.toFixed(1)}k`;
  }
  return views.toString();
}

/** Figma article row: file tile + title/sub + eye/views + chevron (dc.html:1845). */
export function HelpArticleRow({ article, categoryName, onOpen }: HelpArticleRowProps) {
  return (
    <button
      type="button"
      onClick={() => onOpen(article._id)}
      className="w-full flex items-center gap-3.5 p-[14px_22px] border-t border-[var(--color-border-tertiary)] cursor-pointer transition-colors hover:bg-[var(--color-bg-hover)] text-left focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[var(--color-primary-500)] focus-visible:outline-none"
    >
      <span className="w-[38px] h-[38px] rounded-button flex-none grid place-items-center bg-[var(--color-bg-muted)]">
        <FileText className="w-[18px] h-[18px] text-[var(--color-text-tertiary)]" />
      </span>
      <span className="flex-1 min-w-0">
        <span className="block text-label font-bold text-[var(--color-text-primary)] truncate">
          {article.title}
        </span>
        <span className="block text-body-xs text-[var(--color-text-tertiary)] mt-0.5 truncate">
          {categoryName} · {getReadTime(article.content)}
        </span>
      </span>
      <span className="text-[11.5px] font-semibold text-[var(--color-text-tertiary)] flex items-center gap-1.5 flex-none">
        <Eye className="w-3.5 h-3.5 text-[var(--color-text-tertiary)]" />
        {formatViews(article.views)}
      </span>
      <ChevronRight className="w-4 h-4 text-[var(--color-layout-header-icon-secondary)] flex-none" />
    </button>
  );
}

export default HelpArticleRow;
